import { CFSItem } from ".";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { isHtmlUrl, isValidImageUrl, isVideo } from "src/utils/commonCheck";
import { checkMediaType } from "src/utils/mediaType.utils";

interface NFTImageProps {
  item?: CFSItem;
  imgURL?: string;
  height?: number | string;
  objectFit?: 'fill' | 'contain' | 'cover' | 'none' | 'scale-down';
  isDetailPage?: boolean;
}

export const NFTImage = ({ item, imgURL, height, objectFit, isDetailPage }: NFTImageProps) => {
  const [mediaType, setMediaType] = useState<string>('');
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const getImage = useMemo(() => {
    if (imgURL) {
      return imgURL;
    } if (item?.items?.[0]?.fields?.imageUrl) {
      return item?.items?.[0]?.fields?.imageUrl;
    } if (item?.includes?.Asset?.[0]?.fields?.file?.url) {
      return `http:${ item?.includes?.Asset?.[0]?.fields?.file.url }`;
    }
    return '';
  }, [imgURL, item?.items, item?.includes]);

  const getMediaType = useCallback(
    async () => {
      if (isVideo(getImage)) {
        setMediaType('video');
        return;
      } if (isHtmlUrl(getImage)) {
        setMediaType('html');
        return;
      } if (isValidImageUrl(getImage)) {
        setMediaType('image');
        return;
      }
      const type = await checkMediaType(getImage);
      setMediaType(type ?? '');
      return;
  }, [getImage]);

  useEffect(() => {
    if (getImage && isDetailPage) {
      getMediaType();
    }
  }, [getImage, isDetailPage]);

  useEffect(() => {
    if (videoRef) {
      videoRef.current?.load();
    }
  }, []);

  return (
    <>
      {getImage ? (
        <>
          { (isVideo(getImage) || mediaType === 'video') ? (    
            <video
            ref={ videoRef }
            controls
            loop
            muted
            playsInline
            autoPlay={true}
            style={{
              width:  '100%',
              height:  height ? height : 'auto'
            }}
          >
            <source src={ getImage } />
          </video>
          ) : (isHtmlUrl(getImage) || mediaType === 'html') ? (
            <iframe
              src={ getImage }
              width="100%"
              style={{ minHeight: height || '100%', border: 'none', WebkitOverflowScrolling: 'touch' }}
              height="100%"
              scrolling="no"
              title="Product" />
          ) : (
            <img style={{ width: '100%', height: height || 'auto', objectFit: objectFit || 'contain' }} src={ getImage } alt="Product" />
          ) }
        </>
      ) : (
        <></>
      )}
    </>
  );
};
